import { get, set } from 'idb-keyval';
import { res, ui, state, prefs } from './stores.js';
import { get as storeGet } from 'svelte/store';
import { allTokenTypes } from './card_actions.js';
import { getCard } from './game.js';

let cardImages = {};

let imagesLastUpdated = '15/11';

export let cardImagesLoaded = false;

let iconsPrefix = 'links/'
let shipsPrefix = 'ships/'

function convertIconName(icon){
    let _res = storeGet(res);
    if(icon == 'attack-indicator') return iconsPrefix+'attack-indicator.png';
    if(icon == 'actions' || icon == 'action') return 'actions.png';
    if(icon == 'activation' || icon == 'activations') return 'activations.png';
    if(icon == 'away team' || icon == 'away teams') return 'away-team.png';
    if(_res.traits.includes(icon)) return iconsPrefix+'trait-'+icon+'.png';
    if(_res.suits.includes(icon)) return iconsPrefix+'suit-'+icon+'.png';
    if(_res.tracks.includes(icon)) return iconsPrefix+'track-'+icon+'.png';
    if(_res.tokens.includes(icon)) return iconsPrefix+'resource-'+icon+'.png';
    if(_res.ships.includes(icon)) return shipsPrefix+noAbbrevs(icon)+'.png';
    if(Object.values(_res.dashboards).some(d => d.image == icon)){
        return icon;
    }
    return iconsPrefix+icon+'.png';
}

function parseDate(date){
    //console.log(date);
    let match = date.match(/(?<day>[0-9]+)\/(?<month>[0-9]+)\/?(?<year>[0-9]+)?-(?<time>[0-9]+)?/)
    if(match){
        if(match.groups.time){
            return new Date(parseInt(match.groups.time));
        }
        let date = parseInt(match.groups.month) + parseInt(match.groups.day) / 31;
        if(match.groups.year){
            date += parseInt(match.groups.year) * 100;
        }else{
            if(match.groups.month >= new Date().getMonth() + 2){
                date += (new Date().getFullYear() - 1) * 100; // If ahead of now then presume last year
            }else{
                date += new Date().getFullYear() * 100; //
            }
            
        }
        //console.log(date)
        return date;
    }
    return -Infinity;
}

function parseChangedOn(card){
    if(!card.changedOn) return -Infinity;
    return parseDate(card.changedOn);
}

export function changedSince(newCard, origCard){
    if(parseChangedOn(newCard) > parseChangedOn(origCard)) return true;
    return false;
}

const loadImage = (url, c, forceReload) => new Promise((resolve, reject) => {

    /*const img = new Image();
    img.addEventListener('load', () => resolve(img));
    img.addEventListener('error', (err) => reject(err));
    img.src = url;*/
    //if(c.name == 'Unrest') url = ; // All Unrest are the same (for now)
    if(!c) return reject(new Error(`No card for image ${url}`));


    get(url).then(val => {
        if(!window.navigator.onLine || !forceReload && val && parseChangedOn(c) < parseDate(val.changed) && parseDate(imagesLastUpdated) <= parseDate(val.changed) && val.blob.type == 'image/png'){
            let imageURL = URL.createObjectURL(val.blob);
            let img = new Image();
            img.src = imageURL;
            //console.log(c.name, val.changed, imagesLastUpdated)
            //img.addEventListener('load', () => resolve(img));
            //img.addEventListener('error', (err) => reject(err));
            resolve(img);
        }else if(parseDate(imagesLastUpdated) < parseChangedOn(c)){
            reject(`Card ${c.name} (${c.id}) changed since last image update, so reverting to text`);
        }else{
            //console.log(url)
            //console.log(`Loading ${c.name || c} fresh via URL ${url}`)
            let saveURL = url;
            if(forceReload) url = url+'?'+Math.floor(Math.random() * 1000000000);
            fetch(url)
                .then(response => {
                    if(response.headers.get('content-type')?.includes('image/png')){
                        response.blob().then(
                            blob => {
                                set(saveURL, {changed: imagesLastUpdated, blob});
            
                                let imageURL = URL.createObjectURL(blob);
                                let img = new Image();
                                img.src = imageURL;
                                //img.addEventListener('load', () => resolve(img));
                                //img.addEventListener('error', (err) => reject(err));
                                resolve(img);
                            });
                    }else{
                        reject('Unable to load')
                    }
                }).catch(e => { 
                    reject(e);
                });
                ;
                /*const img = new Image();
                let c = document.createElement('canvas');
                let ctx = c.getContext('2d');
                img.addEventListener('load', function() {
                    resolve(this);
                    c.width = this.naturalWidth;
                    c.height = this.naturalHeight;
                    console.log('here');
                    ctx.drawImage(this, 0,0);
                    console.log('here2');
                    c.toBlob((blob) => {
                        set(url, {changed: imagesLastUpdated, blob});
                    }, 'image/png');
                    console.log('here3');
                    
                });
                img.addEventListener('error', (err) => reject(err));
                img.src = url;*/
        }
    }).catch((e) =>{
        if(c.RefNumbers)
        reject(e);
    });
});



export function getAllCardSources(){
    return cardSources;
}

export function cardKey(c){
    if(c.id) return `${c.id}${c.name}`;
    return c.name;
}

export function getDashboard(p){
    //console.log(p.dashboard, cardImages, storeGet(state));
    if(p.dashboard && p.dashboard.image && cardImages[p.dashboard.image]) return cardImages[p.dashboard.image].src;
    return '';
    return cardImages['dashboards'].src;
}

export async function loadCardImages(cards, callBack, forceReload = false){
    //forceReload = true;
   if(storeGet(res).stagingSheet) forceReload = true;
    if(cardImagesLoaded && !forceReload) return;
    let _res = storeGet(res);
    //console.log(Object.values(_res.dashboards).map(d => d.image))
    let icons = [..._res.icons, ..._res.ships, 'action', 'actions', 'attack', 'away-teams', 'drone', 'guard-mil', 'guard-res', 'guard-inf', 'mil-guard', 'res-guard', 'inf-guard', 'spec-res', 'spec-mil', 'spec-inf', 'away team', 'res-focus', 'inf-focus', 'mil-focus', 'inf-restriction', 'mil-restriction','res-restriction'];
    //let sources = getRequiredSources(cards);
    //let images = await fetchSources(sources);
    let percentPerCard = 100/(/*cards.length +*/ icons.length);
    let progress = 0;
    let promises  = []

    /*let params = new URLSearchParams(location.search);
    if(params.has('reloadImages')){
        forceReload = true;
    }*/

    for(let c of icons){
        let fn = convertIconName(c);
        //if(c.name == 'Unrest') fn = 'https://imperium-playtest.web.app/cards/3unr1-unrest.png';
        if(fn){
            promises.push(new Promise((resolve, reject) => {
                    loadImage(fn, c, forceReload).then( (img) => {
                    cardImages[c] = img;
                    progress += percentPerCard;
                    if(callBack)  callBack(progress);
                    resolve();
                }).catch( (err) => {
                    //console.warn('could not load image for '+c+' ('+fn+')', err);
                    progress += percentPerCard;
                    if(callBack)  callBack(progress);
                    resolve();
                });
            }));
        }else{
            console.log('no fn', c);
        }
    }

    await Promise.all(promises);
    //console.log(cardImages)
    if(window.navigator.onLine) cardImagesLoaded = true; // just in case you need to reload when you go online
}

export function getCardURL(card){
    if(!cardImages[cardKey(card)]){
        return false;
    }
    return cardImages[cardKey(card)].src;
}

function noAbbrevs(icon){
    let abbrevs = ['iks','uss','irw'];
    for(let a of abbrevs){
        icon = icon.replace(`${a}_`.split('').join('.'), `${a}_`)
    }
    //console.log('no abbrevs', icon)
    return icon;
}

export function getIconURL(icon){
    let alwaysLocal = ['handSize'];
    if(icon.startsWith('_generic_ship_')) return 'ships/uss_rio_grande.png';
    if(alwaysLocal.includes(icon)) return `${icon}.png`;
    //if(icon.includes('enterprise')) console.log('enterprise', icon, icon.replaceAll('.', '').replaceAll(' ','_'), storeGet(res).ships);
    //let shipIcon = icon.replaceAll('.','');
    if(!storeGet(prefs).oldCards && !storeGet(res).ships.includes(icon)){
        return getNewIcon(icon);
    }
    //icon = noAbbrevs(icon);
    if(!cardImages[icon]){
        //console.log('Unable to find icon '+icon);
        icon = noAbbrevs(icon);
        if(cardImages[icon]) return cardImages[icon].src;
        //console.log('Unable to find icon even after conversion '+icon);
        return false;
    }
    return cardImages[icon].src;
}

let setsWithImages  = ['1', '2', '3']

let cardImageOverrides = ['Mirok', 'Holosuite', 'Sarina Douglas']

// hasOfficialImage() ran two res.cards.find()s per call on every card re-render;
// index the names once per card list instead.
let imageIndexFor = null;
let daggerNames;
let namesWithImages;
function imageIndex(){
    let cards = storeGet(res).cards;
    if(imageIndexFor !== cards){
        imageIndexFor = cards;
        daggerNames = new Set(cards.filter(d => d.id.includes('†')).map(d => d.name));
        namesWithImages = new Set(cards.filter(d => setsWithImages.some(i => d.id.startsWith(i))).map(d => d.name));
    }
}

export function hasOfficialImage(c){
    //if(c.name == 'Mirok' || c.name == 'Holographic Drone Ship' && c.id.startsWith('1') || c.name == "U.S.S. Enterprise-C"  && c.id.startsWith('1')) return false; // Until the updated image comes out!
    //if(c.id.endsWith('†')) return false; // for now
    if(cardImageOverrides.includes(c.name)) return false;
    if(c.hasBeenUpdated) return false; // to update for later
    imageIndex();
    if(!c.id.includes('†') && daggerNames.has(c.name)){
        console.log(`[image] for ${c.name} has been replaced`, c);
        c.hasBeenUpdated = true;
        return false;
    }
    if(setsWithImages.some(i => c.id.startsWith(i))) return true;
    if(c.id.endsWith('•') || c.id.endsWith('○')){
        if(namesWithImages.has(c.name)) return true;
    }
    return false;
    //return && !c.id.startsWith('1LOC'); // Just until images are fixed
}

export function officialImage(c){
    if(setsWithImages.some(i => c.id.startsWith(i))) return c.id.split('/')[0];
    if(c.id.endsWith('•') || c.id.endsWith('○')){
        let card = storeGet(res).cards.find(d => d.name == c.name && setsWithImages.some(i => d.id.startsWith(i)));
        if(card) c = card;
    }
    return c.id.split('/')[0];
}

export function preloadNewImages(cards){
    let images = [];
    for(let c of cards){
        if(!hasOfficialImage(c)) continue;
        let url = `./cards/${c.id.split('/')[0]}.png`;
        let img = new Image();
        img.src = url;
        images.push(img);
    }
    ui.update(ui => {
        ui.images = images; // To stop them being lost?
        return ui;
    })
}

let trackTypes = [...storeGet(res).trackTypes, 'treachery', 'collective'];

export function getNewIcon(icon){
    let _res = storeGet(res);
    let ret = icon;
    icon = icon.toLowerCase();
    if(icon.includes('!')) icon = icon.split('!')[0]; // If we ever add '!' to traits rethink this...!
    if(icon == 'away-teams') return `assets/other/away-team.svg`;
    if(icon == 'away') return `assets/other/away-team.svg`;
    if(icon == 'drone') return `assets/other/drone.svg`;
    if(icon == 'platoon') return `assets/other/platoon.svg`;
    if(icon == 'web') return `assets/other/web.svg`;
    if(icon == 'swarm') return `assets/other/swarm.svg`;
    if(icon == '?vp') return `assets/vp/vp-variable.svg`;
    if(icon == 'actions') ret = 'action';
    if(icon.includes(' ')) ret = icon.replaceAll(' ', '-');
    ret = ret.replaceAll(`'`, `-`); // for e.g. jem'hadar)
    ret = ret.replaceAll(`vau-n-akat`, 'vau-nakat'); // Manual fix because of someone being inconsistent
    if(_res.suits.includes(icon)){
        return `assets/suits/${ret}.svg`;
    }else if(_res.traits.includes(icon)){
        return `assets/traits/${ret}.svg`;
    }else if(icon.endsWith('-focus')){ 
        return `assets/focuses/${ret}.svg`;
    }else if(icon.endsWith('-restriction')){
        return `assets/restrictions/${ret}.svg`;
    }else if(icon.startsWith('deck-')){
        return `assets/decks/${ret}.svg`;
    }else if(icon.startsWith('spec-')){
        let [spec, body] = icon.split('-');
        let type = trackTypes.find(t => t.startsWith(body)) || body;
        return `assets/specialties/${type}.svg`;
    }else if(icon.startsWith('vp-')){
        return `assets/vp/${ret}.svg`;
    }else if(icon.endsWith('vp')){
        return `assets/vp/vp-${icon.slice(0, -2)}.svg`;
    }else if(icon.endsWith('-skill')){
        let [body, skill] = icon.split('-');
        return `assets/skills/skill-${body}.svg`;
    }else if(allTokenTypes().includes(icon)){
        return `assets/resources/${ret}.svg`;
    }else if(trackTypes.includes(icon)){
        return `assets/specialties/${ret}.svg`;
    }else{
        return `assets/other/${ret}.svg`;
    }
}

function getNextKey(key){
    if (key === 'Z' || key === 'z') {
      return String.fromCharCode(key.charCodeAt() - 25) + String.fromCharCode(key.charCodeAt() - 25); // AA or aa
    } else {
      var lastChar = key.slice(-1);
      var sub = key.slice(0, -1);
      if (lastChar === 'Z' || lastChar === 'z') {
        // If a string of length > 1 ends in Z/z,
        // increment the string (excluding the last Z/z) recursively,
        // and append A/a (depending on casing) to it
        return getNextKey(sub) + String.fromCharCode(lastChar.charCodeAt() - 25);
      } else {
        // (take till last char) append with (increment last char)
        return sub + String.fromCharCode(lastChar.charCodeAt() + 1);
      }
    }
    return key;
  };

let currentShipCode = 'A';
let shipCodes = {};


export function getShipCode(card, ship){
    let key = `${card}_${ship}`
    if(shipCodes[key]) return shipCodes[key];
    shipCodes[key] = currentShipCode;
    currentShipCode = getNextKey(currentShipCode);
}

let currentVisitorCode = 0;
let visitorCodes = {};

export function getVisitorCode(v){
    let names = getCard(v).name.toUpperCase().split(' ');
    if(names.length == 1) return names[0];
    if(names.some(n => n == 'Q')) return names.join(' ');
    return names[1];
    if(visitorCodes[v]) return visitorCodes[v];
    visitorCodes[v] = `Q${currentVisitorCode++}`;
}

export function resetCodes(){
    currentShipCode = 'A';
    shipCodes = {};
    currentVisitorCode = 0;
    visitorCodes = {};
}
